import {StateCreator} from 'zustand'
import {TSwitch} from '../types/project.type'

type State = {
  switches: (TSwitch | null)[]
}
type Action = {
  setSwitches: (switches: (TSwitch | null)[]) => void
}
export type SwitchesSlice = State & Action

const createSwitchesSlice: StateCreator<SwitchesSlice> = set => ({
  switches: [],
  setSwitches: switches => set({switches: switches}),
})

export default createSwitchesSlice
